import { FormGroup, ValidationErrors } from '@angular/forms'

const MAX_SLOT_SIZE = 30

export class SlotSizeValidator {
  constructor(private from: string, private to: string, private size: string) {
    this.validate = this.validate.bind(this)
  }

  validate(form: FormGroup): ValidationErrors {
    const isEmpty = !form.value[this.from] || !form.value[this.to] || !form.value[this.size]
    if (isEmpty) return null

    const capacity = parseInt(form.value[this.size])
    const [hFrom, mFrom] = form.value[this.from].split(":").map(t => parseInt(t))
    const [hTo, mTo] = form.value[this.to].split(":").map(t => parseInt(t))
    const from = hFrom * 60 + mFrom
    const to = hTo * 60 + mTo
    const slotSize = ((to - from) / capacity)
    
    return  slotSize <= MAX_SLOT_SIZE ? null : { slotSize: { max: MAX_SLOT_SIZE, current: slotSize } }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/forms/validators/slot-size.validator.ts